import { render, staticRenderFns } from "./DsSalesRank.vue?vue&type=template&id=225d3f58&scoped=true"
import script from "./DsSalesRank.vue?vue&type=script&lang=js"
export * from "./DsSalesRank.vue?vue&type=script&lang=js"
import style0 from "./DsSalesRank.vue?vue&type=style&index=0&id=225d3f58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d3f58",
  null
  
)

export default component.exports